import React from 'react';
import ReactDOM from 'react-dom/client';
import { Capacitor } from '@capacitor/core';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './components/AuthProvider.js';

// iOS zooms in — and never back out — whenever a form field smaller than 16px
// takes focus, which strands the user at 2x after something as ordinary as
// clearing the assistant conversation (its composer is 0.8rem). Android's
// WebView doesn't do this, so locking the scale is what gives the two apps the
// same behaviour. Applied only inside the native shell: the web app keeps
// pinch-to-zoom, which real browser users need.
if (Capacitor.isNativePlatform()) {
    document.querySelector('meta[name="viewport"]')?.setAttribute(
        'content',
        'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover',
    );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
    <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
